import React from 'react'
import Myroom from './Myroom'

const Models = () => {
    
  return (
      <>
      <Myroom />
      </>
  )
}

export default Models